import ee from "./ee";
import en from "./en";
import fi from "./fi";
import lt from "./lt";
import lv from "./lv";
import no from "./no";
import ru from "./ru";
import se from "./se";

const byLanguage = {
    ee,
    en,
    fi,
    lt,
    lv,
    no,
    ru,
    se
};

export default byLanguage;
